exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* UU5.Forms.Label */\n.uu5-forms-input-wrapper {\n  padding: 0 0.5em;\n}\n.uu5-forms-input-wrapper-cover {\n  display: table;\n  width: 100%;\n}\n.uu5-forms-input-button-wrapper {\n  display: table-cell;\n  width: 1%;\n  padding-left: .3em;\n  vertical-align: top;\n}\n.uu5-forms-input-button {\n  height: 2.4em;\n  width: 2.4em;\n  padding: 0;\n}\n.uu5-forms-input-button-glyphicon.uu5-bricks-glyphicon {\n  position: relative;\n}\n.uu5-forms-input-wrapper .uu5-bricks-glyphicon {\n  right: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  align-items: center;\n  width: unset;\n  justify-content: center;\n  position: absolute;\n  height: 2.45em;\n  line-height: 2.45em;\n  vertical-align: middle;\n  top: 0;\n  text-align: center;\n  pointer-events: none;\n  color: #ccc;\n  padding-left: 0.7em;\n  padding-right: 0.7em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./forms/internal/input-wrapper.less
// module id = 320
// module chunks = 0